import type { IAuthenticationService } from "@/application/ports/services";

export class ForgotPasswordUseCase {
	constructor(private authService: IAuthenticationService) {}

	async execute(email: string): Promise<{ success: boolean; error?: string }> {
		return this.authService.forgotPassword(email);
	}
}
